module.exports = __webpack_public_path__ + "static/media/splash2.caf3ddc2.jpg";